module.exports = __webpack_public_path__ + "static/media/video-course.2558d969.jpg";